/**
 * The related layout components rollouts.
 */
export const EXPERIMENTS = {
    ANTS_MIXPANEL_LAZY_LOAD_SESSION_RECORDER: '5062',
GOATS_APP_BOTTOM_SHEET_MOBILE: '3614',
AUTOCOMPLETE_LOCALIZED: '3320',
GOATS_GUEST_BOTTOM_APP_BANNER: '3947',
LIONS_BANNER_LOCAL_SITE_REDIRECT: '4179',
LYNXES_MODERN_HEADER_ENTRY: '4907',
LYNXES_QUESTIONNAIRE_EMAIL_CHECK: '4873',
LYNXES_REMOVE_QUESTIONNAIRE_FROM_BLOCKED_ACTIONS: '5044',
LYNXES_USER_QUESTIONNAIRE_ROUTING: '4785',
MUSTANGS_ROUTING_SEARCH_BAR: '4706',
LIONS_NAVIGATION_ITEMS_FOR_GERMAN_AUDIENCE: '4241'
} as const;
